import React from 'react';
import {Nav} from './Nav/Nav';
import {ProposHeader} from './Header/ProposHeader';
import {Alain} from './Alain/Alain';
import {AmalBedjaoui} from './AmalBedjaoui/AmalBedjaoui';
import {Fruits} from './Fruits/Fruits';
import {Server} from './Server/Server';
import {Nospartenaires} from './Nospartenaires/Nospartenaires';
import {Footer} from '../Footer/Footer';
import { translate, Trans } from 'react-i18next';

class Propos extends React.Component {
  render() {
    return (
  <div>
     <Nav/>
     <ProposHeader/>
     <Alain/>
     <AmalBedjaoui/>
     <Fruits/>
     <Server/>
     <Nospartenaires/>
     <Footer/>
     
  </div>
    );
  }
}

Propos.defaultProps = {
};

export default Propos;


// WEBPACK FOOTER //
// ./src/components/Propos/Propos.js